import { InvoicePrice } from './invoice-price.model';

export class InvoiceLine {
  billingObject: string;
  comment?: string;
  itemCode: string;
  itemDescription: string;
  lineNumber?: number;
  price: InvoicePrice;

  constructor(values= {}) {
    Object.assign(this, values);
    this.price = this.price ? new InvoicePrice(this.price) : new InvoicePrice();
  }
}
